angular.module('bb.util').component('nonAgentInput', {
  controller: nonAgentInput,
  controllerAs: 'vm',
  template: require('./nonAgentInput.html'),
  bindings: {
    selectUser: '<',
    deselectUser: '<',
  },
});

nonAgentInput.$inject = ['$resource'];

function nonAgentInput($resource) {
  const vm = this;
  const NonAgentSearch = $resource('/nonagent/search');

  vm.search = name => {
    vm.loadingUsers = true;
    vm.deselectUser();
    vm.cancelSearch = true;
    NonAgentSearch.query({ name }).$promise.then(function (searchUserResults) {
      vm.searchUserResults = searchUserResults.map(user => {
        const userModified = { ...user };
        userModified.addressName = user.companyName;
        userModified.workType = {
          Photographer: 'Photographer',
          'Pest Control': 'Pest Control',
          Appraisal: 'Appraiser',
          'Home Inspection': 'Home Inspector',
        }[user.type];
        return userModified;
      });
      vm.foundUsers = true;
      vm.loadingUsers = false;
    });
  };

  vm.agentSuggest = val => {
    if (!val) return;

    return NonAgentSearch.query({ name: val }).$promise.then(
      function (searchUserResults) {
        let results = [];
        if (!vm.cancelSearch)
          results = searchUserResults.map(user => {
            const userModified = { ...user };
            userModified.addressName = user.companyName;
            userModified.workType = {
              Photographer: 'Photographer',
              'Pest Control': 'Pest Control',
              Appraisal: 'Appraiser',
              'Home Inspection': 'Home Inspector',
            }[user.type];
            return userModified;
          });
        vm.cancelSearch = false;
        return results;
      },
    );
  };

  vm.onAgentSelect = $item => {
    vm.agentSuggestName = null;
    vm.select($item);
  };

  vm.onAgentEnter = () => {
    if (!vm.agentSuggestName) return;

    vm.search(vm.agentSuggestName);
  };

  vm.select = item => {
    vm.searchUserResults = null;
    vm.selectUser(item);
  };
}

export {};
